import React from 'react'
import { connect } from 'react-redux'
import styles from './CodeViewer.module.css'
// import Editor from '@monaco-editor/react'
import AceEditor from 'react-ace'

// Import Ace Build modes & themes
import 'ace-builds/src-noconflict/mode-python'
import 'ace-builds/src-noconflict/mode-c_cpp'
import 'ace-builds/src-noconflict/theme-github'
import 'ace-builds/src-noconflict/ext-language_tools'

const mpCode = `
from machine import Pin
import time

led = Pin(2, Pin.OUT)

while True:
    led.toggle()
    time.sleep(0.5)
`

function CodeViewer(props) {
    return (
        <div className={styles.CodeViewerContainer}>
            <AceEditor
                style={{
                    height: '100%',
                    width: '100%',
                    fontSize: `${props.fontSize || 13}px`,
                    lineHeight: '1.6',
                    fontFamily: '"Cascadia Code","Fira Code","JetBrains Mono","Consolas",monospace',
                }}
                mode={props.currentMode.isMicroPythonMode ? 'python' : 'c_cpp'}
                theme="github"
                name="code-editor"
                readOnly={true}
                value={props.codes}
                showPrintMargin={false}
                highlightActiveLine={false}
                setOptions={{
                    showLineNumbers: true,
                    tabSize: 4,
                    useWorker: false,
                    showGutter: true,
                }}
            />

            {/* <AceEditor
                mode="python"
                theme="tomorrow"
                value={mpCode}
                // readOnly={readOnly}
                highlightActiveLine={false}
                showPrintMargin={false}
                // width="100%"
                height="100%"
                fontSize={14}
                wrapEnabled={true}
                setOptions={{
                    showLineNumbers: true,
                    tabSize: 2,
                    useWorker: false, // disable error checker for MicroPython
                }}
            /> */}
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        worker: state.scratchGui.worker,
        currentMode: state.scratchGui.script.currentMode,
        codes: state.scratchGui.script.codes,
    }
}

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CodeViewer)
